import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#FFD700]/20 py-10 px-4" data-id="element-118">
      <div className="max-w-3xl mx-auto text-center" data-id="element-119">
        <div className="text-[#FFD700] text-2xl font-black tracking-widest mb-4" data-id="element-120">
          🎵 MEGAPACK MÚSICA LISTA
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-121">
          El sistema de planificación musical más completo para docentes de
          Música del mundo hispanohablante. De España a México. De Colombia a
          Chile. De Guatemala a Argentina. Educación Primaria / Básica y
          Educación Secundaria / Media. Diseñado para funcionar en cualquier
          país donde se hable español.
        </p>
        <p className="text-gray-500 text-sm italic mb-6" data-id="element-122">
          Porque enseñar Música no debería costarte todos los fines de semana
          del año. En ningún país del mundo.
        </p>
        <div className="h-px bg-[#FFD700]/20 mb-6" data-id="element-123" />
        <p className="text-gray-600 text-xs mb-2" data-id="element-124">
          © MegaPack Música Lista — Todos los derechos reservados
        </p>
        <p className="text-gray-600 text-[10px] italic" data-id="element-125">
          Los precios están expresados en dólares estadounidenses (USD). El
          cobro se procesa automáticamente en la moneda local de tu país al
          momento del pago.
        </p>
      </div>
    </footer>;
}